// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page wrapper ── */
.cert-list-page {
  display: flex;
  justify-content: center;
  padding: 24px 16px 64px;
  min-height: 100%;
}

.cert-list-container {
  width: 100%;
  max-width: 820px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* ── Header ── */
.cert-list-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.cert-list-icon-wrap {
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 16px;
  background: rgba(59, 179, 174, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

.cert-list-icon {
  color: #48D1CC !important;
  font-size: 28px !important;
}

.cert-list-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
}

.cert-list-subtitle {
  margin: 4px 0 0;
  color: #9aa3ad;
  font-size: 14px;
}

/* ── Grid ── */
.cert-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

/* ── Card ── */
.cert-card {
  --card-glow: var(--badge-color, #3bb3ae);
  position: relative;
  background: rgba(14, 27, 27, 0.85);
  border-radius: 16px;
  border: 1.5px solid rgba(255, 255, 255, 0.05);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.cert-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 120px;
  height: 120px;
  background: radial-gradient(circle, var(--card-glow) 0%, transparent 70%);
  opacity: 0.04;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.cert-card:hover {
  transform: translateY(-3px);
  border-color: var(--card-glow);
  box-shadow: 0 8px 20px -8px rgba(0, 0, 0, 0.5), 0 0 12px -6px var(--card-glow);
}

.cert-card:hover::before {
  opacity: 0.08;
}

.cert-card-terminal {
  opacity: 0.95;
}

/* ── Card top row (Badge + Status) ── */
.cert-card-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cert-card-badge {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.25s ease;
}

.cert-card:hover .cert-card-badge {
  transform: scale(1.03);
}

/* ── Card name ── */
.cert-card-name {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.3;
  letter-spacing: -0.1px;
}

.cert-card-desc {
  margin: 0;
  font-size: 13px;
  color: #8c9ba5;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ── Status badges ── */
.cert-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10.5px;
  font-weight: 700;
  border-radius: 20px;
  padding: 3px 10px;
  white-space: nowrap;
}

.cert-status-completed {
  background: rgba(59, 179, 174, 0.12);
  color: #48d1cc;
  border: 1px solid rgba(75, 227, 207, 0.15);
}

.cert-status-failed {
  background: rgba(239, 83, 80, 0.12);
  color: #ef5350;
  border: 1px solid rgba(239, 83, 80, 0.15);
}

.cert-status-expired {
  background: rgba(255, 167, 38, 0.12);
  color: #ffa726;
  border: 1px solid rgba(255, 167, 38, 0.15);
}

/* ── Meta details row ── */
.cert-card-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
}

.cert-meta-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #8c9ba5;
  font-weight: 500;
}

.cert-meta-divider {
  color: rgba(255, 255, 255, 0.12);
  font-size: 9px;
  -webkit-user-select: none;
          user-select: none;
}

.cert-meta-pass {
  color: #48d1cc;
  font-weight: 600;
}

/* ── Footer actions ── */
.cert-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding-top: 10px;
}

.cert-card-price {
  display: flex;
  flex-direction: column;
}

.price-label {
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c7a86;
  font-weight: 700;
  line-height: 1;
}

.price-value {
  font-size: 16px;
  font-weight: 700;
  color: #ffb703;
  margin-top: 1px;
}

.price-free {
  font-size: 16px;
  font-weight: 700;
  color: #2ec4b6;
}

.cert-card-action {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
}

.cert-card-action-full {
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding-top: 10px;
}

/* ── CTA buttons ── */
.cert-btn {
  width: 100%;
  padding: 8px 14px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.cert-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.cert-btn:not(:disabled):hover {
  transform: translateY(-1px);
}

.cert-btn-enroll {
  background: rgba(59, 179, 174, 0.1);
  color: #48d1cc;
  border: 1.5px solid rgba(59, 179, 174, 0.4);
}

.cert-btn-enroll:not(:disabled):hover {
  background: rgba(59, 179, 174, 0.25);
  border-color: #48d1cc;
  box-shadow: 0 0 12px rgba(75, 227, 207, 0.15);
}

.cert-btn-pay {
  background: #ffb703;
  color: #071414;
}

.cert-btn-pay:not(:disabled):hover {
  background: #ffc83b;
  box-shadow: 0 0 12px rgba(255, 183, 3, 0.3);
}

.cert-btn-start {
  background: linear-gradient(135deg, #3bb3ae, #0099a8);
  color: #fff;
}

.cert-btn-start:not(:disabled):hover {
  box-shadow: 0 0 16px rgba(59, 179, 174, 0.35);
}

.cert-btn-exam {
  background: linear-gradient(135deg, #e76f51, #f4a261);
  color: #fff;
}

.cert-btn-exam:not(:disabled):hover {
  box-shadow: 0 0 16px rgba(231, 111, 81, 0.35);
}

.cert-btn-failed {
  background: rgba(239, 83, 80, 0.08);
  color: #ef5350;
  border: 1px solid rgba(239, 83, 80, 0.3);
}

.cert-btn-failed:not(:disabled):hover {
  background: rgba(239, 83, 80, 0.16);
  border-color: #ef5350;
  box-shadow: 0 0 12px rgba(239, 83, 80, 0.18);
}

.cert-btn-view {
  background: rgba(59, 179, 174, 0.1);
  color: #48d1cc;
  border: 1px solid rgba(75, 227, 207, 0.25);
}

.cert-btn-view:not(:disabled):hover {
  background: rgba(59, 179, 174, 0.2);
  border-color: #48d1cc;
}

/* ── Empty state ── */
.cert-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  color: #9aa3ad;
  text-align: center;
  background: #0e1b1b;
  border-radius: 18px;
  border: 1px solid #484848;
}

/* ── Skeletons ── */
.cert-card-skeleton {
  pointer-events: none;
  cursor: default;
}

.cert-skeleton {
  border-radius: 8px;
  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);
  background-size: 200% 100%;
  animation: certSkeleton 1.4s ease infinite;
}

.cert-skeleton-badge  { width: 52px; height: 52px; border-radius: 14px; }
.cert-skeleton-title  { width: 70%; height: 18px; margin-top: 4px; }
.cert-skeleton-meta   { width: 90%; height: 12px; margin-top: 4px; }
.cert-skeleton-btn    { width: 100%; height: 38px; border-radius: 12px; margin-top: 8px; }

@keyframes certSkeleton {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .cert-grid {
    grid-template-columns: 1fr;
  }
  .cert-list-title {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Certifications/CertificationList/CertificationList.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,eAAe;AACf;EACE,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,yEAAyE;EACzE,aAAa;EACb,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,8EAA8E;AAChF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qDAAqD;EACrD,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA,wBAAwB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACxE,wBAAwB,UAAU,EAAE,YAAY,EAAE,eAAe,EAAE;AACnE,wBAAwB,UAAU,EAAE,YAAY,EAAE,eAAe,EAAE;AACnE,wBAAwB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAEzF;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,qBAAqB;AACrB;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ── Page wrapper ── */\n.cert-list-page {\n  display: flex;\n  justify-content: center;\n  padding: 24px 16px 64px;\n  min-height: 100%;\n}\n\n.cert-list-container {\n  width: 100%;\n  max-width: 820px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* ── Header ── */\n.cert-list-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.cert-list-icon-wrap {\n  width: 56px;\n  height: 56px;\n  min-width: 56px;\n  border-radius: 16px;\n  background: rgba(59, 179, 174, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cert-list-icon {\n  color: #48D1CC !important;\n  font-size: 28px !important;\n}\n\n.cert-list-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.cert-list-subtitle {\n  margin: 4px 0 0;\n  color: #9aa3ad;\n  font-size: 14px;\n}\n\n/* ── Grid ── */\n.cert-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n/* ── Card ── */\n.cert-card {\n  --card-glow: var(--badge-color, #3bb3ae);\n  position: relative;\n  background: rgba(14, 27, 27, 0.85);\n  border-radius: 16px;\n  border: 1.5px solid rgba(255, 255, 255, 0.05);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  cursor: pointer;\n  overflow: hidden;\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n.cert-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 120px;\n  height: 120px;\n  background: radial-gradient(circle, var(--card-glow) 0%, transparent 70%);\n  opacity: 0.04;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.cert-card:hover {\n  transform: translateY(-3px);\n  border-color: var(--card-glow);\n  box-shadow: 0 8px 20px -8px rgba(0, 0, 0, 0.5), 0 0 12px -6px var(--card-glow);\n}\n\n.cert-card:hover::before {\n  opacity: 0.08;\n}\n\n.cert-card-terminal {\n  opacity: 0.95;\n}\n\n/* ── Card top row (Badge + Status) ── */\n.cert-card-top-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.cert-card-badge {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.25s ease;\n}\n\n.cert-card:hover .cert-card-badge {\n  transform: scale(1.03);\n}\n\n/* ── Card name ── */\n.cert-card-name {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.3;\n  letter-spacing: -0.1px;\n}\n\n.cert-card-desc {\n  margin: 0;\n  font-size: 13px;\n  color: #8c9ba5;\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* ── Status badges ── */\n.cert-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 10.5px;\n  font-weight: 700;\n  border-radius: 20px;\n  padding: 3px 10px;\n  white-space: nowrap;\n}\n\n.cert-status-completed {\n  background: rgba(59, 179, 174, 0.12);\n  color: #48d1cc;\n  border: 1px solid rgba(75, 227, 207, 0.15);\n}\n\n.cert-status-failed {\n  background: rgba(239, 83, 80, 0.12);\n  color: #ef5350;\n  border: 1px solid rgba(239, 83, 80, 0.15);\n}\n\n.cert-status-expired {\n  background: rgba(255, 167, 38, 0.12);\n  color: #ffa726;\n  border: 1px solid rgba(255, 167, 38, 0.15);\n}\n\n/* ── Meta details row ── */\n.cert-card-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n.cert-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #8c9ba5;\n  font-weight: 500;\n}\n\n.cert-meta-divider {\n  color: rgba(255, 255, 255, 0.12);\n  font-size: 9px;\n  user-select: none;\n}\n\n.cert-meta-pass {\n  color: #48d1cc;\n  font-weight: 600;\n}\n\n/* ── Footer actions ── */\n.cert-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  padding-top: 10px;\n}\n\n.cert-card-price {\n  display: flex;\n  flex-direction: column;\n}\n\n.price-label {\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #6c7a86;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.price-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffb703;\n  margin-top: 1px;\n}\n\n.price-free {\n  font-size: 16px;\n  font-weight: 700;\n  color: #2ec4b6;\n}\n\n.cert-card-action {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.cert-card-action-full {\n  width: 100%;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  padding-top: 10px;\n}\n\n/* ── CTA buttons ── */\n.cert-btn {\n  width: 100%;\n  padding: 8px 14px;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 700;\n  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.cert-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.cert-btn:not(:disabled):hover {\n  transform: translateY(-1px);\n}\n\n.cert-btn-enroll {\n  background: rgba(59, 179, 174, 0.1);\n  color: #48d1cc;\n  border: 1.5px solid rgba(59, 179, 174, 0.4);\n}\n\n.cert-btn-enroll:not(:disabled):hover {\n  background: rgba(59, 179, 174, 0.25);\n  border-color: #48d1cc;\n  box-shadow: 0 0 12px rgba(75, 227, 207, 0.15);\n}\n\n.cert-btn-pay {\n  background: #ffb703;\n  color: #071414;\n}\n\n.cert-btn-pay:not(:disabled):hover {\n  background: #ffc83b;\n  box-shadow: 0 0 12px rgba(255, 183, 3, 0.3);\n}\n\n.cert-btn-start {\n  background: linear-gradient(135deg, #3bb3ae, #0099a8);\n  color: #fff;\n}\n\n.cert-btn-start:not(:disabled):hover {\n  box-shadow: 0 0 16px rgba(59, 179, 174, 0.35);\n}\n\n.cert-btn-exam {\n  background: linear-gradient(135deg, #e76f51, #f4a261);\n  color: #fff;\n}\n\n.cert-btn-exam:not(:disabled):hover {\n  box-shadow: 0 0 16px rgba(231, 111, 81, 0.35);\n}\n\n.cert-btn-failed {\n  background: rgba(239, 83, 80, 0.08);\n  color: #ef5350;\n  border: 1px solid rgba(239, 83, 80, 0.3);\n}\n\n.cert-btn-failed:not(:disabled):hover {\n  background: rgba(239, 83, 80, 0.16);\n  border-color: #ef5350;\n  box-shadow: 0 0 12px rgba(239, 83, 80, 0.18);\n}\n\n.cert-btn-view {\n  background: rgba(59, 179, 174, 0.1);\n  color: #48d1cc;\n  border: 1px solid rgba(75, 227, 207, 0.25);\n}\n\n.cert-btn-view:not(:disabled):hover {\n  background: rgba(59, 179, 174, 0.2);\n  border-color: #48d1cc;\n}\n\n/* ── Empty state ── */\n.cert-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  color: #9aa3ad;\n  text-align: center;\n  background: #0e1b1b;\n  border-radius: 18px;\n  border: 1px solid #484848;\n}\n\n/* ── Skeletons ── */\n.cert-card-skeleton {\n  pointer-events: none;\n  cursor: default;\n}\n\n.cert-skeleton {\n  border-radius: 8px;\n  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);\n  background-size: 200% 100%;\n  animation: certSkeleton 1.4s ease infinite;\n}\n\n.cert-skeleton-badge  { width: 52px; height: 52px; border-radius: 14px; }\n.cert-skeleton-title  { width: 70%; height: 18px; margin-top: 4px; }\n.cert-skeleton-meta   { width: 90%; height: 12px; margin-top: 4px; }\n.cert-skeleton-btn    { width: 100%; height: 38px; border-radius: 12px; margin-top: 8px; }\n\n@keyframes certSkeleton {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Responsive ── */\n@media (max-width: 600px) {\n  .cert-grid {\n    grid-template-columns: 1fr;\n  }\n  .cert-list-title {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
